import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];


/**
 * Inner-page header on the live sky, with the page name set large behind it.
 */
export default function PageHero({ title, children, aside, size = 'lg', backdrop }) {
  const word = backdrop ?? (typeof title === 'string' ? title : '');

  return (
    <header id="page-hero" className="theme-dark sky-dawn relative overflow-hidden pt-36 pb-20 sm:pt-44 sm:pb-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-[0.18em] left-0 right-0 select-none whitespace-nowrap text-center display text-[24vw] leading-none text-white/15"
      >
        {word}
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-[-10%] top-[10%] h-[60%] w-[60%] rounded-full bg-[radial-gradient(closest-side,rgba(255,255,255,0.35),transparent)]"
      />

      <div className="frame relative grid gap-8 lg:grid-cols-12 lg:items-end">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE }}
          className={`display lg:col-span-8 ${
            size === 'sm' ? 'text-[2.3rem] leading-[0.98] sm:text-6xl lg:text-[4.5rem]' : 'text-[3rem] sm:text-7xl lg:text-[6.5rem]'
          }`}
        >
          {title}
        </motion.h1>
        {(children || aside) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.35 }}
            className="lg:col-span-4"
          >
            {children && <p className="lede">{children}</p>}
            {aside}
          </motion.div>
        )}
      </div>

    </header>
  );
}
